<div class="col-lg-12">
  <div class="panel panel-default">
    <div class="panel-heading">

    </div>
    <div class="panel-body">
      <p *ngIf="loading; else form">
        Loading ...
      </p>
      <ng-template #form>
       <div class="card">
        <div class="card-body">
          <form [formGroup]="userForm" novalidate *ngIf="!loading" (ngSubmit)="userForm.valid && submitUserForm()">
            <input type="hidden" formControlName="id"/>

            <div class="form-group mt-2">
              <label>First Name : <span class="required">*</span></label>
              <input type="text" formControlName="firstName" class="form-control" [attr.autocomplete]="'off'">
              <em *ngIf="(f.firstName.touched && f.firstName.invalid)" class="text-danger">
                First name is required
              </em>
            </div>

            <div class="form-group mt-2">
              <label>Last Name : <span class="required">*</span></label>
              <input type="text" formControlName="lastName" class="form-control" [attr.autocomplete]="'off'">
              <em *ngIf="(f.lastName.touched && f.lastName.invalid)" class="text-danger">
                Last name is required
              </em>
            </div>

            <div class="form-group mt-2">
              <label>Country : <span class="required">*</span> </label>
              <select formControlName="countryId" (change)="onCountryChange($event.target.value)" class="form-control">
                <option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>
              </select>
              <em *ngIf="(f.countryId.touched && f.countryId.invalid)" class="text-danger">
                Country is required
              </em>
            </div>

            <div class="form-group mt-2">
              <label>City : <span class="required">*</span> </label>
              <select formControlName="city" class="form-control">
                <option *ngFor="let city of cities" [value]="city.cityName">{{ city.cityName }}</option>
              </select>
              <em *ngIf="(f.city.touched && f.city.invalid)" class="text-danger">
                City is required
              </em>
            </div>

            <div class="form-group mt-2">
              <label>Account phone number : <span class="required">*</span></label>
              <input type="text" formControlName="phone" class="form-control" [attr.autocomplete]="'off'">
              <em *ngIf="(f.phone.touched && f.phone.invalid)" class="text-danger">
                Phone is required
              </em>
            </div>

            <div class="form-group mt-2">
              <label>Email : </label>
              <input type="text" formControlName="email" class="form-control" [attr.autocomplete]="'off'">
            </div>

            <div class="form-group mt-2">
              <label>Password : <span class="required" *ngIf="userToEdit == null || (userToEdit && !userToEdit.hasOwnProperty('id')) ">*</span> </label>
              <input type="password" formControlName="password" class="form-control" [attr.autocomplete]="'off'" autocomplete="off">
              <div *ngIf="(f.password.touched && f.password.invalid)" class="text-danger">
                <em *ngIf="f.password.errors.required">Password is required</em>
                <em *ngIf="f.password.errors.minlength">Password must be at least 6 characters</em>
              </div>
            </div>

            <div class="form-group mt-2">
              <label>Confirm password : </label>
              <input type="password" formControlName="confirmPassword" class="form-control" [attr.autocomplete]="'off'" autocomplete="off">
              <em *ngIf="f.confirmPassword.touched && f.confirmPassword.invalid && f.confirmPassword.errors.mustMatch" class="text-danger">
                Confirm password don't match
              </em>
            </div>

            <div class="form-group mt-2">
              <button type="button" class="btn btn-default me-3" id="btn-back" (click)="back_to_previous()">Back</button>

              <button type="submit" class="btn btn-success" id="btn-submit" [disabled]="!userForm.dirty || userForm.invalid || (userForm.valid && submitting)" >
                {{ submitting ? 'Saving ...' : 'Save' }}
              </button>
            </div>
          </form>
        </div>
       </div>
      </ng-template>
    </div>
  </div>
</div>
